// extracted by mini-css-extract-plugin
export default {"root":"BottomNavigation_root__hHtMZ"};